import { Pipe, PipeTransform } from '@angular/core';
import { Porder } from '../models/entities/porder';


@Pipe({
  name: 'warehouse-transfer-pipe'
})

export class PorderPipe implements PipeTransform {
  
  constructor(){}



  transform(porder: Porder, field: string): any {
    let result = porder[field];

    if (field == 'returnPo') {
      let html = "<div class='multi-labels'>";
      if  (result)  {
        html += "<div class='label-orange'> Retour </div>"
      }  

      if (porder.closed) {
        html += "<div class='label-red'> Clos </div>"
      }
      html += "</div>";
      result = html;
    }

    return result;
  }
}
